<template>
  <header :class="{'bg-white full-height': smMenu, 'lg-hover-states': notIndex}" class="line-height-2 fixed left-0 top-0 col-12 z-20 overflow-auto">
    <div class="flex flex-wrap">
      <h1 class="m0 h3 regular">
        <router-link to="/" class="no-change">{{ title }}</router-link>
      </h1>

      <div class="flex-auto right-align sm-hide md-hide lg-hide">
        <button @click="toggleMenu" class="m0 p0 border-none h2 pointer no-select menu-button">{{ buttonIcon }}</button>
      </div>

      <ul :class="{ 'xs-hide': !smMenu }" class="col-12 sm-flex-auto list-reset m0 sm-pl3 pt2 sm-pt0">
        <template v-for="page in menu">
          <router-link :to="page.url" tag="li" exact class="h3 mb1 sm-mb0 sm-inline-block sm-pr3 lg-hover-active">
            <a>{{ page.title }}</a>
          </router-link>
        </template>
      </ul>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'app-header',
    data () {
      return {
        smMenu: false,
        showProjects: false,
        focussed: null,
        menu: [
          { title: 'Information', url: '/information' },
          { title: 'News', url: '/news' }
          // { title: 'Projects', url: '/projects' }
        ]
      }
    },
    computed: {
      title () {
        return this.$store.state.title
      },
      notIndex () {
        return this.$route.path !== '/' && this.$route.name !== 'NotFound'
      },
      buttonIcon () {
        return this.smMenu ? '×' : '≡'
      },
      projects () {
        return this.$store.state.projectList
      },
      experiences () {
        return this.$store.state.experienceList
      },
      route () {
        return this.$route
      },
      isProject () {
        return this.$route.name === 'Experience' ||
          (this.$route.name && this.$route.name.indexOf('Project') === 0)
      },
      firstImgSlide () {
        return this.focussed &&
          this.focussed.acf.slides &&
          this.focussed.acf.slides.find(s => s.acf_fc_layout === 'image')
      },
      image () {
        return this.firstImgSlide &&
          this.firstImgSlide.image
      }
    },
    methods: {
      toggleMenu () {
        this.smMenu = !this.smMenu
        this.focussed = null
      },
      closeMenu () {
        this.smMenu = false
        this.showProjects = false
      },
      link (slug) {
        return `/projects/${slug}`
      },
      eLink (slug) {
        return `/experiences/${slug}`
      },
      focus (project) {
        this.focussed = project
      },
      blur () {
        this.focussed = null
      },
      thisIsActive (project) {
        return this.focussed && project.ID === this.focussed.ID
      }
    },
    watch: {
      route (newVal) {
        this.closeMenu()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/partials/AppHeader.vue